<div class="login-root">
  <app-navbar></app-navbar>

  <div class="login-page">
    <div class="login-wrapper">
      <div class="login-card">
        <img class="emblem" src="/assets/logo/Logo.png" alt="logo" />
        <h2 class="title">ระบบบริหารสินทรัพย์</h2>
        <p class="subhead">{{ subheadText }}</p>
        <p class="subtitle">กรุณากรอกเลขบัตรประชาชนก่อนทำเพื่อเข้าใช้งาน</p>

        <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <div class="col-md-4 position-relative" style="width:100%">
            <label for="idCard" class="position-absolute" style="top: -0.5rem; left: 1rem;">เลขบัตรประชาชน
              <span class="text-danger">*</span>
            </label>
            <input
              type="text"
              id="idCard"
              formControlName="idCard"
              class="form-control id-input"
              placeholder="x-xxxx-xxxxx-xx-x"
              autocomplete="off"
              [ngClass]="{'is-invalid': loginForm.get('idCard')?.invalid && loginForm.get('idCard')?.touched}"
            />

            <div *ngIf="loginForm.get('idCard')?.invalid && loginForm.get('idCard')?.touched" class="text-danger small mt-1">
              กรุณากรอกเลขบัตรประชาชน
            </div>
          </div>

          <button class="login-btn" type="submit">เข้าสู่ระบบ</button>
        </form>
      </div>
    </div>
  </div>
</div>
